(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearnerViewOnlineLessonModalCtrl", ["$rootScope", "authService", "$uibModalInstance", "$location", "learningItemOnlineLesson", "$window", "scormService", "newWindow", learnerViewOnlineLessonModalCtrl]);
    function learnerViewOnlineLessonModalCtrl($rootScope, authService, $uibModalInstance, $location, learningItemOnlineLesson, $window, scormService, newWindow) {
        var vm = this;
        vm.scormWindow = null;
        vm.learningItemOnlineLesson = learningItemOnlineLesson;
        //const userAgent = navigator.userAgent.toLowerCase();
        //const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
        //vm.newWindow = (jQuery as any).browser.mobile || newWindow || isTablet || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        vm.newWindow = newWindow;
        vm.openCourse = openCourse;
        if ($location.protocol() === "http") {
            vm.learningItemOnlineLesson.launchFileUrl = vm.learningItemOnlineLesson.launchFileUrl.replace("https", "http");
        }
        var url;
        if ($location.port() !== 80 && $location.port() !== 443)
            url = $location.protocol() + "://" + $location.host() + ":" + $location.port();
        else
            url = $location.protocol() + "://" + $location.host();
        $window.addEventListener("message", receiveMessage, false);
        if (vm.learningItemOnlineLesson.onlineLessonTypeId === 1) {
            scormService.init(vm.learningItemOnlineLesson);
        }
        else {
            var endpointUrl = url + "/xapi/";
            var actor = {
                objectType: "Agent",
                name: [authService.authentication.userFullName],
                account: [{
                        accountServiceHomePage: url,
                        accountName: authService.authentication.userPersonSeq
                    }]
            };
            var activityId = url + vm.learningItemOnlineLesson.launchFileUrl.replace("/" + vm.learningItemOnlineLesson.launchFile, "");
            activityId = activityId.replace(/%20/g, "");
            vm.learningItemOnlineLesson.launchFileUrl += "?endpoint=" + endpointUrl + "&actor=" + window.encodeURIComponent(window.JSON.stringify(actor)) + "&activity_id=" + activityId + "&registration=" + learningItemOnlineLesson.registration;
            vm.learningItemOnlineLesson.launchFileUrl += "&auth=Bearer%20" + authService.getToken();
        }
        if (vm.newWindow) {
            setTimeout(function () {
                vm.openCourse();
            }, 0);
        }
        vm.scormWindow = null;
        ////////////////////////////////////////////////////////////////////////
        function openCourse() {
            if (vm.scormWindow && !vm.scormWindow.closed) {
                vm.scormWindow.focus();
                //alert("The course is already open.");
                return;
            }
            $rootScope.$broadcast("pauseIdleTimeout");
            var windowName = "scormWindow_" + vm.learningItemOnlineLesson.assignmentId;
            //vm.scormWindow = $window.open(url + vm.learningItemOnlineLesson.launchFileUrl, "_blank", "");
            vm.scormWindow = $window.open(url + vm.learningItemOnlineLesson.launchFileUrl, windowName, "");
            vm.scormWindow.onbeforeunload = function () {
                vm.scormWindow = null;
            };
        }
        function receiveMessage(event) {
            if (event.data === "closeWindow")
                $uibModalInstance.close();
            console.log(event);
        }
        vm.close = function () {
            $uibModalInstance.close();
        };
        this.$onDestroy = function () {
            //Clear Lectora session storage
            var removeArray = [];
            for (var i = 0; i < sessionStorage.length; i++) {
                if (sessionStorage.key(i).startsWith("Lectora")) {
                    removeArray.push(sessionStorage.key(i));
                }
            }
            for (var key in removeArray) {
                if (removeArray.hasOwnProperty(key)) {
                    sessionStorage.removeItem(removeArray[key]);
                }
            }
        };
        $rootScope.$on("onlineLessonTerminated", function () {
            vm.close();
        });
    }
}());
